import React from "react";
import styles from "../ChartSelector.module.css";
import {
	secondaryTextColor,
	fw400,
	titleS,
} from "../../../../Global.module.css";
import ChartTypes from "../../ChartType.json";
import Charts from "../Charts.json";
import { getChartImage } from "./getChartImage";

const BarChartTypes = [
	ChartTypes.BasicBar,
	ChartTypes.StackedBar,
	ChartTypes.GroupBar,
	ChartTypes.PercentBar,
	ChartTypes.RangeBar,
];
const AreaChartTypes = [ChartTypes.BasicArea, ChartTypes.StackedArea];
const PieChartTypes = [ChartTypes.PieChart, ChartTypes.DonutChart];
const ColumnLineTypes = [ChartTypes.ColumnLine];
const WordCloudTypes = [ChartTypes.WordCloud];
const HistogramTypes = [ChartTypes.Histogram];
const RadarTypes = [ChartTypes.Radar, ChartTypes.RadarMultiLine];
const LineChartTypes = [
	ChartTypes.BasicLine,
	ChartTypes.MultiLine,
	ChartTypes.StepLine,
];

export const getChartTypes = (chart, chartSelected) => {
	let chartTypes = [];
	let list = [];
	switch (chart) {
		case Charts.BarChart:
			chartTypes = [...BarChartTypes];
			break;
		case Charts.AreaChart:
			chartTypes = [...AreaChartTypes];
			break;
		case Charts.PieChart:
			chartTypes = [...PieChartTypes];
			break;
		case Charts.ColumnLine:
			chartTypes = [...ColumnLineTypes];
			break;
		case Charts.WordCloud:
			chartTypes = [...WordCloudTypes];
			break;
		case Charts.Histogram:
			chartTypes = [...HistogramTypes];
			break;
		case Charts.Radar:
			chartTypes = [...RadarTypes];
			break;
		case Charts.LineChart:
			chartTypes = [...LineChartTypes];
			break;

		default:
			break;
	}
	for (let i = 0; i < chartTypes.length; i++) {
		list.push(
			<div className={styles.chartType} key={i}>
				<img
					width="160"
					height="160"
					src={getChartImage(chartTypes[i])}
					alt=""
					onClick={() => chartSelected(chartTypes[i])}
				/>
				<p className={`${secondaryTextColor} ${fw400} ${titleS}`}>
					{chartTypes[i]}
				</p>
			</div>
		);
	}
	return list;
};
